module.exports = {};



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_iterators.js
// module id = ../../../node_modules/core-js/modules/_iterators.js
// module chunks = 0